import CryptoJS from "crypto-js";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Form, Formik, ErrorMessage } from "formik";
import { loginSchema } from "../../utils/yup";
import CloseIcon from "../icons/CloseIcon";
import { fetchUserData, logIn, setUser } from "../../redux/actions";
import CompanySelectionModal from "../modals/CompanySelectionModal";

const LoginPage = () => {
  const secretKey = "DgCMNKKey@555555";
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tokenList, setTokenList] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onSubmit = async (values, { setSubmitting }) => {
    try {
      setLoading(true);

      const key = CryptoJS.enc.Utf8.parse(secretKey);
      const iv = CryptoJS.lib.WordArray.random(16);
      const data = values.password;
      const encrypted = CryptoJS.AES.encrypt(data, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      const password = iv
        .concat(encrypted.ciphertext)
        .toString(CryptoJS.enc.Base64);

      const result = await logIn(values.email, password);

      if (result?.token) {
        const data = result?.token;

        if (Array.isArray(data)) {
          setTokenList(data);
          setIsModalOpen(true);
        } else {
          localStorage.setItem("auth_token", result.token);

          // ✅ Ensure token is available before proceeding
          await new Promise((resolve) => setTimeout(resolve, 100)); // Small delay to ensure cookie is set

          if (localStorage.getItem("auth_token")) {
            const user_data = await fetchUserData();

            if (user_data?.message) {
              toast.error(user_data?.message);
            } else {
              dispatch(setUser(user_data));

              navigate("/self-service/dashboard");
              toast.success("You have been signed in successfully!");
            }
          }
        }
      } else {
        if (result?.message) {
          toast.error(result?.message);
        } else {
          console.log("login result : ", result);
        }
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }

    setSubmitting(false);
  };

  return (
    <section className="account py-40">
      {/* Modal for Token List */}
      {isModalOpen && (
        <CompanySelectionModal
          onClose={() => setIsModalOpen(false)}
          tokenList={tokenList}
        />
      )}
      <Formik
        initialValues={{
          email: "",
          password: "",
        }}
        onSubmit={onSubmit}
        validationSchema={loginSchema}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          setFieldValue,
        }) => (
          <Form>
            <div className="container container-lg">
              <div className="row gy-4">
                {/* Login Card Start */}
                <div className="col-xl-3"></div>
                <div className="col-xl-5">
                  <div className="row gy-4">
                    <div className="col-xl-6">
                      <div className="logo px-16 d-block">
                        <Link to="/" className="mobile-menu__logo">
                          <img
                            src="../../assets/images/logo/dhofar-logo.svg"
                            alt="Logo"
                          />
                        </Link>
                      </div>
                    </div>
                    <div className="col-xl-6 d-flex justify-content-end align-items-center">
                      <Link to="/">
                        <CloseIcon size={14} className="text-neutral-900" />
                      </Link>
                    </div>
                  </div>
                  <h4 className="text-center">
                    <b>Log In</b>
                  </h4>
                  <div className="product-dContent border rounded-24 p-20">
                    <div className="mb-40">
                      <div className="mb-24">
                        <label
                          htmlFor="email"
                          className="text-neutral-900 lable-font mb-8 fw-medium"
                        >
                          E-mail address or Phone number{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="common-input input-font"
                          placeholder="Enter email address"
                          name="email"
                          id="email"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          value={values.email}
                          autoComplete="off"
                        />
                        {errors.email && touched.email && (
                          <ErrorMessage
                            name="email"
                            component="div"
                            className="text-danger lable-font"
                          />
                        )}
                      </div>
                      <div className="mb-24">
                        <div className="row">
                          <label
                            htmlFor="password"
                            className="text-neutral-900 lable-font mb-8 fw-medium"
                          >
                            Password <span className="text-danger">*</span>
                          </label>
                          <div className="position-relative">
                            <input
                              type={showPassword ? "text" : "password"} // Toggle between text and password
                              className="common-input input-font"
                              id="password"
                              placeholder="Enter password"
                              name="password"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.password}
                              autoComplete="new-password"
                            />
                            {/* Toggle button */}
                            <span
                              className={`toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer ph ${
                                showPassword ? "ph-eye" : "ph-eye-slash"
                              }`}
                              onClick={() => setShowPassword(!showPassword)}
                              style={{ cursor: "pointer" }}
                            />
                            {errors.password && touched.password && (
                              <ErrorMessage
                                name="password"
                                component="div"
                                className="text-danger lable-font "
                              />
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="text-center">
                        <button
                          type="submit"
                          className="btn btn-main py-16 px-30 w-full"
                          disabled={loading}
                        >
                          Log In
                        </button>
                      </div>
                      <div className="my-24">
                        <p className="text-neutral-900">
                          <b>
                            Forgot your password?&nbsp;
                            <Link
                              to="/forgot-password"
                              className="btn-primary text-decoration-underline"
                            >
                              Reset it
                            </Link>
                          </b>
                        </p>
                      </div>
                      <div className="my-24">
                        <p className="text-neutral-900">
                          <b>
                            Don’t have an account yet?&nbsp;
                            <Link
                              to="/account"
                              className="btn-primary text-decoration-underline"
                            >
                              Sign up
                            </Link>
                          </b>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Login Card End */}
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </section>
  );
};

export default LoginPage;
